<template>
    <div class="def-index-title">
        <DefTitle :result="1">
            <h1>{{ result.title }}</h1>
        </DefTitle>
    </div>

</template>

<script>
    import DefTitle from "../DefTitle/DefTitle.vue";

    export default {
        name: "DefIndexTitle",
      components: {DefTitle},
        selector: '.def-index-title',
        props: ['result'],
    }
</script>

<style lang="scss" scoped>
.def-index-title {
    text-align: center;
}
</style>